<template>
  <PanelItem :index="index" :field="field">
    <template #value>
      <FormKeyValueTable
        v-if="theData.length > 0"
        :edit-mode="false"
      >
        <FormKeyValueHeader
          :key-label="field.keyLabel"
          :value-label="field.valueLabel"
        />

        <div class="key-value-items divide-y divide-zinc-200 overflow-hidden dark:divide-zinc-700">
          <div
            v-for="item in theData"
            :key="item.key"
            class="key-value-item flex"
          >
            <div
              class="w-48 shrink-0 px-3 py-2.5 text-sm text-zinc-700 dark:text-zinc-200"
            >
              {{ item.key }}
            </div>

            <div
              class="min-w-0 flex-1 border-s border-zinc-200 px-3 py-2.5 text-sm text-zinc-600 dark:border-zinc-700 dark:text-zinc-300"
            >
              {{ formatValue(item.value) }}
            </div>
          </div>
        </div>
      </FormKeyValueTable>

      <p v-else>&mdash;</p>
    </template>
  </PanelItem>
</template>

<script>
import map from 'lodash/map'

export default {
  props: ['index', 'resource', 'resourceName', 'resourceId', 'field'],

  data: () => ({ theData: [] }),

  created() {
    this.theData = map(
      Object.entries(this.field.value || {}),
      ([key, value]) => ({
        key: `${key}`,
        value,
      })
    )
  },

  methods: {
    /**
     * Format a key-value cell for read-only display
     *
     * @param {*} value
     * @returns {string}
     */
    formatValue(value) {
      if (value === null || value === undefined || value === '') {
        return '—'
      }

      if (typeof value === 'object') {
        return JSON.stringify(value)
      }

      return `${value}`
    },
  },
}
</script>
